package twist.mena.sports.admin.external

@JsName("marked")
external object MarkedModule {
    fun parse(markdown: String): String
}

fun renderMarkdown(markdown: String): String {
    return try {
        js("marked.parse(markdown)") as String
    } catch (e: Exception) {
        // Fallback: basic HTML escaping
        markdown
            .replace("&", "&amp;")
            .replace("<", "&lt;")
            .replace(">", "&gt;")
            .replace("\n", "<br>")
    }
}
